import React, { Component } from 'react';
import Iframe from 'react-iframe';
import { Container, Grid, Card, Header, Button, Image } from 'semantic-ui-react';
// import ScrollableAnchor, { goToAnchor } from  'react-scrollable-anchor';
import { settings, history } from '../helpers';
import { FiExternalLink } from 'react-icons/fi';
import { strings } from '../common/translations';

import Particles from 'react-particles-js';
var Spinner = require('react-spinkit');

class Section extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loadingIframe: true
    }

    this.references = [];

    props.data.map((section, index) => {
      return this.references[index] = React.createRef();
    })
    
    this.refTop = React.createRef();
  }

  componentDidMount() {

    const URLsection = window.location.hash.split("?")[1];
    URLsection && this.handleScrollToSection(URLsection);

    // NAVIGATE SECTION BY GET
    // const parameterInURL = window.location.hash.split("?");
    // console.log("PARAMETER URL -> ", parameterInURL);
    // if (parameterInURL.length > 1) {
    //   const sectionInURL = parameterInURL.slice(-1)[0];
    //   console.log("SECTION IN URL -> ", sectionInURL);
    // }
    // this.handleScrollTo(this.references[0])
    // window.addEventListener('DOMContentLoaded', this.handleScrollTo(this.references[0]));
  }

  componentDidUpdate() {}

  hideSpinner = () => {

    this.setState({
      loadingIframe: false
    });
  };

  handleScrollTo = (elRef, section) => {

    // section && history.push(window.location.pathname + window.location.hash.substr(2) + "?" + section)

    // Incase the ref supplied isn't ref.current
    const el = elRef.current ? elRef.current : elRef
    const URLparameter = window.location.hash.split("?")[1];
    history.push(window.location.pathname + window.location.hash.substr(2).replace(URLparameter, ''))
    // Scroll the element into view
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  handleScrollToSection = (ele) => {

    const URLparameter = window.location.hash.split("?")[1];
    if (process.env.NODE_ENV === "development") {
      URLparameter ? history.push(window.location.pathname + window.location.hash.substr(2).replace(URLparameter, ele)) : history.push(window.location.pathname + window.location.hash.substr(2) + "?" + ele);
    } else {
      URLparameter ? history.push(window.location.hash.substr(2).replace(URLparameter, ele)) : history.push(window.location.hash.substr(2) + "?" + ele);
    }

    let offsetTop  = document.getElementById(ele).offsetTop;
    // var right = document.getElementById("#right");
    window.scrollTo({
        top: offsetTop - 50, 
        behavior: "smooth"
    });
}

chartContainerStyle = function(height) {
  return {
    minHeight: height,
  }
}

  renderSectionCards = () => {
    return (
      this.props.data.map((chart, index) => {
        return (
          <Card 
            key={chart.id} 
            onClick={() => { this.handleScrollToSection(chart.codeName) }}
            >
            <Card.Content>
              {
                chart.icon && <Image src={chart.icon} floated='left' size='mini' />
              }
              <Card.Header style={chart.icon ? { paddingLeft: '20%' } : { paddingLeft: 0 }}>
                {chart.title}
              </Card.Header>
              <Card.Description dangerouslySetInnerHTML={{ __html: chart.description }} />
            </Card.Content>
          </Card>
        )
      })
    )
  }

  renderChart = (chart) => {
    if (chart.iframeURL)
      return <div className="iframe-container">
        {this.state.loadingIframe ? (<div className="spinner-container">
          <Spinner
            className="loading"
            name="three-bounce"
            color="white"
            fadeIn="none"
          />
        </div>) : null}
        <Iframe url={settings.VIZ_URL + chart.iframeURL}
          width="100%"
          height={chart.height}
          onLoad={this.hideSpinner}
        /></div>;

    const TagName = chart.component;

    return <TagName />
  };

  renderSectionIframes = () => {
    return (
      this.props.data.map((chart, index) => {
        return (
          <div className={'chart-row ' + (chart.id % 2 === 0 ? 'bg-white' : 'bg-light')}
            key={chart.id}
            ref={this.references[index]}
            id={chart.codeName}>
            <Grid reversed={chart.layout === 'right' && 'computer'} className={chart.id % 2 === 0 ? 'bg-light' : 'bg-white'}>
              <Grid.Row className="p-4">
                <Grid.Column width={chart.layout === 'full' ? 16 : 4} className={chart.layout === 'full' ? '' : ''}>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={!chart.fullText ? 16 : (chart.layout === 'full' ? 8 : 16)}>
                        <Header
                          as='h2'
                          className={"mb-2 chart-row_title " + (chart.layout === 'full' ? (!chart.fullText ? "text-center" : "text-right") : "text-left")}>{chart.title}</Header>
                      </Grid.Column>
                      {chart.fullText && 
                        <Grid.Column 
                          className={"chart-row_description text-left"} 
                          width={chart.layout === 'full' ? 8 : 16} 
                          dangerouslySetInnerHTML={{ __html: chart.fullText }}
                        >
                      </Grid.Column>}
                    </Grid.Row>
                  </Grid>
                </Grid.Column>

                <Grid.Column width={chart.layout === 'full' ? 16 : 12} style={this.chartContainerStyle(chart.height)}>
                  {this.renderChart(chart)}
                </Grid.Column>

              </Grid.Row>
            </Grid>
            <footer className="text-center d-flex">
              {chart.id !== 1 && <Button className="mr-auto text-truncate" onClick={() => { this.handleScrollToSection(this.props.data[chart.id - 2].codeName) }}><span>{this.props.data[chart.id - 2].title}</span></Button>}
              {this.props.data.length !== chart.id && <Button className="ml-auto text-truncate" onClick={() => { this.handleScrollToSection(this.props.data[chart.id].codeName) }}><span>{this.props.data[chart.id].title}</span></Button>}
            </footer>
          </div>
        )
      })
    )
  }

  render() {
    return (
      <Container fluid className="section">
        <div className="chart-list bg-animation" ref={this.refTop}>
          <Particles className="position-absolute w-100 h-100" />
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column width={5}>
                <Header as="h1" className="section_title">{this.props.title}</Header>
                <p className="section_description" dangerouslySetInnerHTML={{ __html: this.props.description }} />
                <p className="section_description">
                  <FiExternalLink /> <span><a className="text-white" rel="noopener noreferrer" href={strings.COMMON.MANUAL_URL} target="_blank">{strings.COMMON.MANUAL}</a></span>
                </p>
              </Grid.Column>
              <Grid.Column width={11}>
                <Card.Group>
                  {this.renderSectionCards()}
                </Card.Group>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        {this.renderSectionIframes()}
        {/*
        <Button className="btn-back-top" onClick={() => { this.handleScrollTo(this.refTop) }}>
        <FiChevronUp />
        </Button>
        */}
      </Container>
    );
  }
}

export default Section;